import { useTranslation } from 'react-i18next'
import LearnerUserMenu from '~/pages/components/LearnerUserMenu'
import { demoPath } from '~/pages/help/demo/demo-path'
import DemoChapterPicker from '~/pages/help/demo/DemoChapterPicker'
import DemoModuleContent from '~/pages/help/demo/DemoModuleContent'
import LearnerPlayerHeader from '~/pages/scorm/components/LearnerPlayerHeader'
import PlayerFrame from '~/pages/scorm/components/PlayerFrame'

/**
 * Le lecteur, en démonstration (#105) : le vrai cadre et son bandeau, sans
 * tentative ouverte, sans contenu chargé ni progression écrite — ouvrir le vrai
 * lecteur démarre une tentative, ce qu'une visite n'a pas à faire.
 */
function PlayerDemo() {
  const { t } = useTranslation()
  // Le module joué est l'étape en cours du parcours de démonstration.
  const path = demoPath(t)
  const playing = path.modules?.find(step => step.myTracking?.completionStatus === 'INCOMPLETE')

  return (
    <PlayerFrame
      fallbackTo="/my-sessions"
      fallbackLabel={t('scorm.player.backToSessions')}
      headerContent={(
        <LearnerPlayerHeader
          sessionName={path.name}
          stepPosition={playing?.position}
          totalSteps={path.modules?.length ?? 0}
          impersonating={false}
        />
      )}
      headerRight={(
        <>
          <DemoChapterPicker />
          <LearnerUserMenu />
        </>
      )}
    >
      <DemoModuleContent backTo="/help" />
    </PlayerFrame>
  )
}

export default PlayerDemo
